import React from 'react';

/**
 * Componente de alerta para sinalizar que o pagamento da assinatura do Clube
 * está pendente/em atraso (última cobrança UNPAID).
 */
const ClubLateIcon = ({ className = "text-danger ms-1", title = "Mensalidade em atraso", ...props }) => {
    return (
        <i 
            className={`fa-solid fa-circle-exclamation ${className}`} 
            title={title} 
            {...props}
        ></i>
    );
};

export default ClubLateIcon;
